import "./style.css"
import { useState, useEffect } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { useTranslation } from "react-i18next";
import {
    changeEmailVerification
} from "../../../actions/profile";
import { useLoading } from "../../../components/LoadingContext";
import { useParams } from "react-router-dom";
import CustomerLogin from "../../../components/auth/CustomerLogin";
import jwtDecode from "jwt-decode";
import { TimerIcon, CheckRoundedIcon } from "../../../components/icons";

const ChangeEmailVerification = () => {
    const { t } = useTranslation();
    const { token } = useParams();
    const { showLoading, closeLoading } = useLoading();
    const [isValidToken, setIsValidToken] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const verificationEmail = async () => {
        showLoading(true)
        const emailVerif = await changeEmailVerification({ token });

        if (emailVerif.desc === "SUCCESS" && emailVerif.code === 200) {
            localStorage.removeItem("token");
            setIsValidToken(true);
            setIsLoading(false);
            closeLoading(true);
        } else {
            setIsValidToken(false);
            setIsLoading(false);
            closeLoading(true);
        }
    }

    useEffect(() => {
        if (token) {
            verificationEmail(token);
        }
    }, [token])

    return (
        <FrontLayout>
            <div className="bg-my-page">
                <div className="tw:w-full tw:mx-auto tw:mt-12 tw:pt-1 tw:px-0 tw:lg:px-2">
                    <div className="custom-mx">
                        <div className="tw:w-full tw:mx-auto tw:px-3 tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:pb-12 tw:!mt-8">
                            {!isLoading && isValidToken ? (
                                <>
                                    <div className="tw:flex tw:flex-wrap tw:-mx-3 tw:mb-12 tw:pt-4">
                                        <div className="tw:w-full tw:px-3 tw:mb-6 tw:flex tw:items-center tw:justify-center">
                                            <i>
                                                <CheckRoundedIcon />
                                            </i>
                                        </div>
                                        <div className="tw:w-full tw:px-3 tw:mb-0">
                                            <h5
                                                className="tw:font-bold! tw:text-center tw:text-[#212529]! tw:mb-1"
                                                dangerouslySetInnerHTML={{
                                                    __html: t("changeEmailVerification.title"),
                                                }}
                                            >
                                            </h5>
                                        </div>
                                        <div className="tw:w-full tw:px-3 tw:mb-6">
                                            <p className="tw:text-center">
                                                {t("changeEmailVerification.desc")}
                                            </p>
                                        </div>
                                        <div className="tw:w-full tw:px-3 tw:mb-4 tw:flex tw:items-center tw:justify-center">
                                            <button
                                                className="btn-login-change-email tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#4a4a4a] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:flex tw:items-center tw:justify-center"
                                                data-bs-toggle="modal"
                                                data-bs-target="#login"
                                            >
                                                <p className="tw:text-center tw:my-0">
                                                    {t("changeEmailVerification.button")}
                                                </p>
                                            </button>
                                        </div>
                                    </div>
                                    <CustomerLogin useModal={true} modalId={"login"} />
                                </>
                            ) : !isLoading && isValidToken ? (
                                <>
                                    <div className="tw:flex tw:flex-wrap tw:-mx-3 tw:mb-12 tw:pt-4">
                                        <div className="tw:w-full tw:px-3 tw:mb-6 tw:flex tw:items-center tw:justify-center">
                                            <i>
                                                <TimerIcon />
                                            </i>
                                        </div>
                                        <div className="tw:w-full tw:px-3 tw:mb-0">
                                            <h5
                                                className="tw:font-bold! tw:text-center tw:text-[#212529]! tw:mb-1"
                                                dangerouslySetInnerHTML={{
                                                    __html: t("changeEmailVerification.failed.title"),
                                                }}
                                            >
                                            </h5>
                                        </div>
                                        <div className="tw:w-full tw:px-3 tw:mb-6">
                                            <p className="tw:text-center">
                                                {t("changeEmailVerification.failed.desc")}
                                            </p>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </FrontLayout>
    );
}

export default ChangeEmailVerification;
